import { render } from "./KeywordSearch.vue?vue&type=template&id=70714b5c"
import script from "./KeywordSearch.vue?vue&type=script&lang=js"
export * from "./KeywordSearch.vue?vue&type=script&lang=js"

import "./KeywordSearch.vue?vue&type=style&index=0&id=70714b5c&lang=scss"

import exportComponent from "/app/tmp/360pt/V3/v2026.8.r2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__